import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MunicipalityStoreConfig } from '@app/municipality-management/models/municipality-management';
import { MunicipalityManagementConfigurationStore } from '@app/municipality-management/services/municipality-management-configuration.store';
import { MunicipalityManagementService } from '@app/municipality-management/services/municipality-management.service';
import { Tenant } from '@app/shared/enums';
import { CustomerCenter } from '@app/shared/services/api/customer-center.service';
import { EditableMunicipalityConfig } from '@app/shared/services/api/municipality.service';
import { AuthService } from '@app/shared/services/auth.service';
import { StringUtility } from '@app/shared/string-utility';
import { environment } from '@env/environment';
import { isNil } from 'lodash';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, tap } from 'rxjs/operators';

@Component({
  selector: 'app-damage-report-tab',
  templateUrl: './damage-report-tab.component.html',
  styleUrls: ['./damage-report-tab.component.scss'],
})
export class DamageReportTabComponent implements OnInit, OnDestroy {
  private _subscriptions$: Subscription = new Subscription();
  private _unsubscribe$ = new Subject<boolean>();

  public municipalityConfig$: Observable<MunicipalityStoreConfig> = of();

  public isBAGCompany = false;

  public isTestingValue = false;

  public isDisabled = false;

  public selectedCustomerCenter?: string;
  public damageReportEmailAddress?: string;

  public damageReportTabForm: FormGroup = this.formBuilder.group({
    isGeneralReportingDamageEnabled: [false],
    isInTestMode: [false],
    dmgRepPwaactive: [false],
  });

  constructor(
    private formBuilder: FormBuilder,
    public authService: AuthService,
    private _service: MunicipalityManagementService,
    private _configStore: MunicipalityManagementConfigurationStore
  ) {
    this.isDisabled = !!!this.authService.permissions.GENERAL_CONFIGURATION_UPDATE;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next(true);
    this._unsubscribe$.complete();
    this._subscriptions$.unsubscribe();
  }

  ngOnInit() {
    this.isBAGCompany = StringUtility.areStringsIdentical(environment.tenant, Tenant.BAYERNWERK);

    this.municipalityConfig$ = this._configStore.municipalityStoreConfiguration$.pipe(
      filter((config: MunicipalityStoreConfig) => !isNil(config.municipality)),
      distinctUntilChanged(),
      tap((config: MunicipalityStoreConfig) => {
        this.damageReportTabForm.patchValue(
          {
            isGeneralReportingDamageEnabled: config.municipality.isGeneralReportingDamageEnabled,
            isInTestMode: config.municipality.isInTestMode,
            dmgRepPwaactive: config.municipality.dmgRepPwaactive,
          },
          { emitEvent: false }
        );

        this.selectedCustomerCenter = config.customerCenter.selected;
        this.damageReportEmailAddress = config.customerCenter.damageReportEmailAddress;
      })
    );

    this._subscriptions$.add(
      this.damageReportTabForm.valueChanges
        .pipe(
          tap((formData) => {
            if (this.damageReportTabForm.dirty) {
              this._configStore.setMunicipalityConfig(formData);
            }
          })
        )
        .subscribe()
    );
  }

  public selectCustomerCenter(customerCenter: CustomerCenter): void {
    this.selectedCustomerCenter = customerCenter.name;
    this.damageReportEmailAddress = customerCenter.damageReportEmailAddress;
    this._configStore.setCustomerCenterConfig(customerCenter);

    this._configStore.setMunicipalityConfig({
      customerCenter: customerCenter.itemId,
      customerCenterId: customerCenter.guid,
    } as EditableMunicipalityConfig);
  }

  public deleteTestData(): void {
    this._subscriptions$.add(this._service.openDeleteTestDataDialog().subscribe());
  }

  public changeEventHandler(): void {
    this._configStore.setCanNavigateValue();
  }
}
